<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content">
      <div class="row" style="margin-left: 5px">
        <div class="header-title-admin">{{'' | i18n: 'warranty-config'}}</div>
      </div>
      <div class="row">
        <div class="col-lg-12 action-btn" style="text-align: right;">
          <button (click)="switchContractTypes()"
          [ngClass]="{ 'btn-selected' : showContractTypes}">{{'' | i18n: 'contract-types'}}</button>

          @if (modelFactorsActive) {
            <button (click)="switchModelFactors()"
            [ngClass]="{ 'btn-selected' : showModelFactors}">{{'' | i18n: 'model-factors'}}</button>
          }

          @if (modelsActive) {
            <button (click)="switchModels()"
            [ngClass]="{ 'btn-selected' : showModels}">{{'' | i18n: 'models'}}</button>
          }

          @if (ageFactorsActive) {
            <button (click)="switchAgeFactors()"
            [ngClass]="{ 'btn-selected' : showAgeFactors }">{{'' | i18n: 'age-factors'}}</button>
          }
          <button (click)="switchToConfigureDates()"
          [ngClass]="{ 'btn-selected' : showConfigurableDate }">{{'' | i18n: 'order-or-delivery'}}</button>
          @if (modelGroupActive) {
            <button (click)="switchToModelGroups()" [ngClass]="{'btn-selected':showModelGroups}">
              {{''|i18n:'model-groups'}}
            </button>
          }
          @if (ageMileageActive) {
            <button (click)="switchAgeMileage()"
              [ngClass]="{ 'btn-selected' : showAgeAndMileage}">
              {{'' | i18n: 'age-and-mileage'}}
            </button>
          }
          @if (groupPricingActive) {
            <button (click)="switchGroupPricing()"
              [ngClass]="{ 'btn-selected' : showGroupPricing}">
              {{'' | i18n: 'group-pricing'}}
            </button>
          }
        </div>
      </div>

      @if (showModelFactors) {
        <div>
          <div class="col-lg-6 serch-panel">
            <div class="form-group">
              <div class="form-group" style="display: grid">
                <label for="Search">{{'' | i18n: 'search'}}:</label>
                <span style="display: flex;">
                  <input type="text" id="Search" name="dealerName" [(ngModel)]="filter.modelCode"
                    placeholder="Model Code..." (keydown.enter)="search()">
                    <button><i (click)="search()" class="fa fa-search" aria-hidden="true"></i></button>
                    <i (click)="clear()" class="fa fa-times" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="header-subtitle-admin">{{'' | i18n: 'model-factors'}}.</div>
            @for (y of availableYears; track y) {
              <button style="margin-left: 0px;margin-right: 5px;" (click)="selectYear(y)"
              [ngClass]="{ 'btn-selected' : selectedYear == y }">{{y}}</button>
            }
            <button (click)="addNewModelCode()">{{'' | i18n: 'add-model-code'}}</button>
            <div class="pagecount-container" style="padding-top: 22px">
              <button (click)="changePage(-1)" class="button button-page" [disabled]="this.filter.page == 0"><img alt=""
                src="assets/images/BMW-previous-144.png"
                width="20px"
                height="20px">
              </button>
              <div class="page-text-container"> {{ filter.page + 1 }} </div>
              <button (click)="changePage(1)" class="button button-page"
                [disabled]="this.modelCodeList?.pageCount <= this.filter.page"><img alt=""
                src="assets/images/BMW-next-144.png"
                width="20px" height="20px">
              </button>
            </div>
            <div class="form-row-container-config">
              <div class="table-header">
                <div class="table-header-item-status">
                  <a (click)="orderBy('modelCode')">{{'' | i18n: 'model-code'}}
                    @if (filter.orderBy == 'modelCode') {
                      <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                    }</a>
                  </div>
                  <div class="table-header-item-status">{{'' | i18n: 'year-valid'}}</div>
                  <div class="table-header-item-chassis">
                    <a (click)="orderBy('description')">{{'' | i18n: 'description'}}@if (filter.orderBy == 'description') {
                      <img
                        src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                    }</a>
                  </div>
                  <div class="table-header-item-licence">
                    <a (click)="orderBy('factor')">{{'' | i18n: 'factor'}}
                      @if (filter.orderBy == 'factor') {
                        <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-licence">
                      <a (click)="orderBy('extendedFactor')">{{'' | i18n: 'ext-factor'}}@if (filter.orderBy == 'extendedFactor') {
                        <img
                          src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                      }</a>
                    </div>
                    <div class="table-header-item-licence">{{'' | i18n: 'update'}}</div>
                  </div>
                  @for (m of modelCodeList?.dataList; track m) {
                    <div class="table-list">
                      @if (m.id) {
                        <div class="table-list-item-status">{{m.modelCode}}</div>
                      }
                      @if (!m.id) {
                        <div class="table-list-item-status"><input type="text" [(ngModel)]="m.modelCode"></div>
                      }
                      @if (m.id) {
                        <div class="table-list-item-status">{{m.validFrom.substring(0, 4)}}</div>
                      }
                      @if (!m.id) {
                        <div class="table-list-item-status">
                          <select [(ngModel)]="modelCodeYear">
                            <option value="2020">2020</option>
                            <option value="2021">2021</option>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                          </select>
                        </div>
                      }
                      <div class="table-list-item-chassis"><input type="text" [(ngModel)]="m.description"></div>
                      <div class="table-list-item-licence"><input type="text" [(ngModel)]="m.factor"></div>
                      <div class="table-list-item-licence"><input type="text" [(ngModel)]="m.extendedFactor"></div>
                      <div class="table-list-item-licence">
                        <button (click)="updateModelCode(m)">{{'' | i18n: 'save'}}</button>
                      </div>
                      @if (!m.id) {
                        <div class="table-list-item-licence">
                          <button (click)="removeModelCode(m)">{{'' | i18n: 'delete'}}</button>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }

            @if (showModels) {
              <app-model [modelsActive]="modelsActive" [modelGroups]="modelGroups"></app-model>
            }

            @if (showContractTypes) {
              <div>
                <div class="header-subtitle-admin">{{'' | i18n: 'contract-types'}}.</div>
                <div class="form-row-container-config">
                  <select [(ngModel)]="selectedContractType" style="width: 600px;margin-bottom: 10px">
                    <option value="null">{{'' | i18n: 'select'}}...</option>
                    @for (c of contractTypes; track c) {
                      <option [ngValue]="c">{{c.contractType}} ({{c.contractCode}})</option>
                    }
                  </select>
                  @if (selectedContractType) {
                    <div class="table-list">
                      <h2>{{selectedContractType.contractType}}
                      - {{selectedContractType.contractPeriod}} {{'' | i18n: 'continue'}}</h2>
                      <div class="table-header">
                        <div class="table-header-item-status">{{'' | i18n: 'contract-type'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'contract-code'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'max-mileage'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'min-mileage'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'max-age-months'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'min-age-months'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'nws-end-mileage'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'best-types'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'active'}}</div>
                        <div class="table-header-item-status">{{'' | i18n: 'update'}}</div>
                      </div>
                      <div class="table-list">
                        <div class="table-list-item-status">{{selectedContractType.contractType}}</div>
                        <div class="table-list-item-status">{{selectedContractType.contractCode}}</div>
                        <div class="table-list-item-status"><input type="text"
                        [(ngModel)]="selectedContractType.acceptMileageMax"></div>
                        <div class="table-list-item-status"><input type="text"
                        [(ngModel)]="selectedContractType.acceptMileageMin"></div>
                        <div class="table-list-item-status"><input type="text"
                          [(ngModel)]="selectedContractType.acceptMonthMax">
                        </div>
                        <div class="table-list-item-status"><input type="text"
                          [(ngModel)]="selectedContractType.acceptMonthMin">
                        </div>
                        <div class="table-list-item-status"><input type="text" [(ngModel)]="selectedContractType.maxMileage">
                        </div>
                        <div class="table-list-item-status">
                          <select [(ngModel)]="selectedContractType.bestType">
                            @for (c of bestTypes; track c) {
                              <option [ngValue]="c">{{c}}</option>
                            }
                          </select>
                        </div>
                        <div class="table-list-item-status">
                          <label class="container" style="text-align: center">
                            <input type="checkbox" [(ngModel)]="selectedContractType.isActive">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div class="table-list-item-status">
                          <button (click)="updateContractType(selectedContractType)"
                          [disabled]="!isContractTypeValid(selectedContractType)">{{'' | i18n: 'update'}}</button>
                        </div>
                      </div>
                      <br>
                        <h2>Calculation Configuration</h2>
                        <div class="table-header">
                          <div class="table-header-item-status">{{'' | i18n: 'year-valid'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'base-rate'}}</div>
                          <div class="table-header-item-status">Avg. Kms</div>
                          <div class="table-header-item-status">{{'' | i18n: 'upper-dev-limit'}} </div>
                          <div class="table-header-item-status">{{'' | i18n: 'upper-limit-factor'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'lower-dev-limit'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'lower-limit-factor'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'Minimum Fee'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'apply-dealer-bonus'}}</div>
                          <div class="table-header-item-status">{{'' | i18n: 'update'}}</div>
                        </div>
                        @for (m of selectedContractType.mileageFactors; track m) {
                          <div class="table-list">
                            <div class="table-list-item-status">{{m.validFrom.substring(0, 4)}}</div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.baseRate"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.averageKms"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.deviationUpperLimit"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.upperLimitFactor"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.deviationLowerLimit"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.lowerLimitFactor"></div>
                            <div class="table-list-item-status"><input type="text" [(ngModel)]="m.minimumFee"></div>
                            <div class="table-list-item-status">
                              <label class="container" style="text-align: center">
                                <input type="checkbox" [(ngModel)]="m.applyDealerBonus">
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="table-list-item-status">
                              @if (m.id) {
                                <button (click)="updateMileageFactor(m, selectedContractType.contractCode)"
                                [disabled]="!isMileageFactorValid(m)">{{'' | i18n: 'update'}}</button>
                              }
                              @if (!m.id) {
                                <button (click)="updateMileageFactor(m, selectedContractType.contractCode)"
                                [disabled]="!isMileageFactorValid(m)">{{'' | i18n: 'save'}}</button>
                              }
                              <div class="table-list-item-status">
                                @if (!m.id) {
                                  <button
                                  (click)="removeMileageFactor(m, selectedContractType)">{{'' | i18n: 'delete'}}</button>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              @if (showAgeFactors) {
                <div>
                  <div class="header-subtitle-admin">{{'' | i18n: 'age-factors'}}.</div>
                  @for (y of availableYears; track y) {
                    <button style="margin: -1px 7px 23px 0px;;" (click)="selectAgeYear(y)"
                    [ngClass]="{ 'btn-selected' : selectedYear == y }">{{y}}</button>
                  }
                  <div class="form-row-container-config">
                    <div class="table-header">
                      <div class="table-header-item-licence-age">{{'' | i18n: 'year-valid'}}</div>
                      <div class="table-header-item-licence-age">{{'' | i18n: 'age-from'}}</div>
                      <div class="table-header-item-licence-age">{{'' | i18n: 'age-to'}}</div>
                      <div class="table-header-item-licence-age">BMW {{'' | i18n: 'age-factors'}}</div>
                      <div class="table-header-item-licence-age">MINI {{'' | i18n: 'age-factors'}}</div>
                      <div class="table-header-item-licence-age">Motorrad {{'' | i18n: 'age-factors'}}</div>
                      <div class="table-header-item-licence-age">{{'' | i18n: 'update'}}</div>
                    </div>
                    @for (m of ageFactors; track m) {
                      <div class="table-list">
                        <div class="table-list-item-chassis-age">{{m.validFrom.substring(0, 4)}}</div>
                        <div class="table-list-item-chassis-age"><input type="text" [(ngModel)]="m.ageFrom"></div>
                        <div class="table-list-item-chassis-age"><input type="text" [(ngModel)]="m.ageTo"></div>
                        <div class="table-list-item-chassis-age"><input type="text" [(ngModel)]="m.bmwFactor"></div>
                        <div class="table-list-item-chassis-age"><input type="text" [(ngModel)]="m.miniFactor"></div>
                        <div class="table-list-item-chassis-age"><input type="text" [(ngModel)]="m.motorradFactor"></div>
                        <div class="table-list-item-chassis-age">
                          @if (m.id) {
                            <button (click)="updateAgeModel(m)">{{'' | i18n: 'update'}}</button>
                          }
                          @if (!m.id) {
                            <button (click)="updateAgeModel(m)">{{'' | i18n: 'save'}}</button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (showConfigurableDate) {
                <app-configurable-date></app-configurable-date>
              }
              @if (showModelGroups) {
                <app-model-group></app-model-group>
              }
              @if (showAgeAndMileage) {
                <app-age-mileage></app-age-mileage>
              }
              @if (showGroupPricing) {
                <app-pricing-matrix></app-pricing-matrix>
              }
            </div>
          </div>
        </div>
